import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notificationData",
  initialState: {
    notification: 0,
    video_notification: [],
    isNotification: false,
  },
  reducers: {
    setVideoNotification: (state, action) => {
      let temp = state.video_notification;
      if(temp.filter(item => item.title === action.payload.title).length > 0) {
        temp = temp.map(item => {
          return item.title === action.payload.title ? action.payload : item;
        });
        state.video_notification = temp;
      } else {
        state.video_notification.push(action.payload)
      }
    },
    setNotificationOpen: (state, action) => {
      state.isNotification = action.payload;
    },
  },
});

export const { setVideoNotification, setNotificationOpen } =
  notificationSlice.actions;

export default notificationSlice.reducer;
